// The matter page's AI summary card with the one control that writes it; a
// fixture matter has no Mongo id and gets no button. The card is keyed on the
// id because useMutationState reads the cache on mount and on cache events
// only: a page moving to another matter needs a fresh mount to see that
// matter's write.

import type { AISummary as AISummaryShape } from "../../data/types";
import { AICard, hasSummary } from "../ai/AICard";
import { useCaseSummaryWrite, useGenerateCaseSummary } from "../../hooks/useGenerateCaseSummary";

interface Props {
  summary: AISummaryShape | undefined;
  caseId?: string;
}

export function AISummary(props: Props) {
  return <MatterSummary key={props.caseId ?? "fixture"} {...props} />;
}

function MatterSummary({ summary, caseId }: Props) {
  const generate = useGenerateCaseSummary();
  const write = useCaseSummaryWrite(caseId);
  return (
    <AICard
      context="matter"
      id={caseId ?? "matter"}
      summaryOverride={hasSummary(summary) ? summary : null}
      onGenerate={caseId ? () => generate.mutate(caseId) : undefined}
      generating={write.pending}
      generateError={write.error}
    />
  );
}
